// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col, Alert, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Banner from '../../components/Banner';
import * as registrationCreators from '../../actions/users/registrationCreators';
import {
  updateLoggedInUser,
  getLoggedInUser
} from '../../actions/authentication/authCreators';
import MyAccountForm from './MyAccountForm';
import UserPhoneVerificationForm from '../users/UserPhoneVerificationForm';
import type { Dispatch } from 'redux';

type Props = {
  router: any,
  getLoggedInUser: Function,
  updateLoggedInUser: Function,
  sendVerificationEmail: Function,
  sendVerificationSMS: Function,
  checkVerificationCode: Function,
  authentication: any,
  organisations: Object[]
};

type State = {
  isSaving: boolean,
  isSending: boolean,
  isVerifying: boolean,
  message: any,
  messageType: any,
  isVerified: boolean,
  hasCustomer: boolean
};

class Account extends React.Component<Props, State> {
  timeoutId: any;

  constructor(props: Props) {
    super(props);
    const { authentication: { user }, organisations } = this.props;
    this.state = {
      isSaving: false,
      message: undefined,
      messageType: undefined,
      isSending: false,
      isVerifying: false,
      isVerified: user.isEmailVerified && user.isMobileVerified,
      hasCustomer: organisations.length > 0
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    // get the user details
    this.props.getLoggedInUser();
  }

  componentWillReceiveProps(nextProps) {
    const { authentication: { user } } = nextProps;
    const isVerified = user.isEmailVerified && user.isMobileVerified;
    this.setState({
      isVerified: isVerified
    });
    if (isVerified && !this.state.hasCustomer) {
      this.navigateToCreateCustomer();
    }
  }

  updateAccountUser = user => {
    this.props.updateLoggedInUser(user).then(
      success =>
        this.setState({
          message: 'Success',
          messageType: 'success'
        }),
      error =>
        this.setState({
          message: error.data.message,
          messageType: 'danger'
        })
    );
  };

  resendEmail = email => {
    this.props.sendVerificationEmail(email).then(
      success =>
        this.setState({
          message: 'Email Sent',
          messageType: 'success'
        }),
      error =>
        this.setState({
          message:
            'There was a problem sending the verification email. Please check your email address and try again.',
          messageType: 'danger'
        })
    );
  };

  resendSMS = phoneNumber => {
    this.setState({ message: undefined });
    this.props.sendVerificationSMS(phoneNumber).then(
      success => {
        this.setState({
          message: 'SMS sent',
          messageType: 'success'
        });
      },
      error => {
        this.setState({
          message: error.data.message,
          messageType: 'danger'
        });
      }
    );
  };

  verifyCode = values => {
    this.setState({ isVerifying: true, message: undefined });
    this.props.checkVerificationCode(values.code).then(
      user => {
        this.setState({ isVerifying: false });
        if (user.isMobileVerified) {
          // update logged in user
          this.props.getLoggedInUser();
          this.setState({
            message: 'Thank you for verifying your mobile number',
            messageType: 'success'
          });
        } else {
          this.setState({
            message: 'That verification code is not valid.',
            messageType: 'danger'
          });
        }
      },
      error => {
        this.setState(error.data.message);
      }
    );
  };

  recheckVerification = () => {
    this.props.getLoggedInUser();
  };

  navigateToDashboard = () => {
    this.props.router.push('/');
  };

  navigateToCreateCustomer = () => {
    this.props.router.push('/customer/create');
  };

  render() {
    const { authentication: { user } } = this.props;

    const bannerTitle =
      user.isEmailVerified && user.isMobileVerified
        ? 'My Account'
        : 'Registration';

    return (
      <div>
        <Helmet>
          <title>My Account | Campaign Targeter</title>
        </Helmet>
        <Banner title={bannerTitle} image="mailbox" />
        <Grid>
          <Row>
            <Col sm={8} smOffset={2} md={8} mdOffset={3} lg={6} lgOffset={3}>
              {!user.isEmailVerified && (
                <Alert bsStyle="info">
                  <p className="help-block">
                    Your email address has not been verified yet. Please click
                    on the link in the email that was sent to your email
                    address.
                  </p>
                  <Button
                    bsStyle="link"
                    onClick={e => this.resendEmail(user.email)}
                    className="normal-link-btn"
                  >
                    Resend the email to {user.email}
                  </Button>
                </Alert>
              )}
              <br />

              {!user.isMobileVerified && (
                <Alert bsStyle="info">
                  <p className="help-block">
                    An SMS with a verification code has been sent the phone
                    number specified below.
                  </p>
                  <br />
                  <UserPhoneVerificationForm
                    onSubmit={this.verifyCode}
                    isVerifying={this.state.isVerifying}
                    resendSMS={this.resendSMS}
                    phone={user.phone}
                  />
                </Alert>
              )}
              <br />

              <MyAccountForm
                onSubmit={this.updateAccountUser}
                initialValues={user}
                message={this.state.message}
                messageType={this.state.messageType}
                isSaving={this.state.isSaving}
                enableReinitialize
                isVerifying={this.state.isVerifying}
                recheckVerification={this.recheckVerification}
                isVerified={this.state.isVerified}
                hasCustomer={this.state.hasCustomer}
                navigateToDashboard={this.navigateToDashboard}
                navigateToCreateCustomer={this.navigateToCreateCustomer}
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    organisations: state.organisations
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      ...registrationCreators,
      getLoggedInUser,
      updateLoggedInUser
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/containers/account/Account.js